import { motion } from "framer-motion";
import { ANSWERS } from "../config";

const choiceEmoji = (value) => {
  if (value === "choice_both") return "✨";
  return value === "choice_a" ? "A" : "B";
};

// Reusable answer controls for standard YES/MAYBE/NO and A/B/BOTH choice cards.
export const AnswerButtons = ({ question, onAnswer, disabled, current }) => {
  const isChoice = question?.format === "CHOICE";
  const options = isChoice
    ? (question.options || []).map((option) => ({ ...option, emoji: choiceEmoji(option.value) }))
    : ANSWERS;

  return (
    <motion.div
      className="answer-row"
      style={isChoice ? { flexDirection: "column", alignItems: "stretch" } : undefined}
      data-testid="answer-buttons"
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.18 }}
    >
      {options.map((a) => (
        <motion.button
          key={a.value}
          type="button"
          data-testid={`answer-${a.value}`}
          className={`answer-btn ${isChoice ? "answer-choice" : `answer-${a.value}`} ${current === a.value ? "active" : ""}`}
          style={isChoice ? { width: "100%", maxWidth: "none", flexDirection: "row", justifyContent: "flex-start", textAlign: "left" } : undefined}
          disabled={disabled}
          whileTap={{ scale: 0.97 }}
          onClick={() => onAnswer(a.value)}
        >
          <span className="answer-emoji">{a.emoji}</span>
          <span className="answer-label">{a.label}</span>
        </motion.button>
      ))}
    </motion.div>
  );
};

export default AnswerButtons;
